(function () {
  if (window.__tzCalendarCartInit) return;
  window.__tzCalendarCartInit = true;

  var STORAGE_KEY = 'tiziano.calendarCart.deferred.v1';

  function roots() {
    return Array.from(document.querySelectorAll('[data-tz-calendar-cart]'));
  }

  function payload(root) {
    try {
      return JSON.parse(root.querySelector('[data-tz-calendar-payload]').textContent);
    } catch (error) {
      return { items: [] };
    }
  }

  function deferredItems() {
    try {
      var data = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      return data && Array.isArray(data.items) ? data : null;
    } catch (error) {
      return null;
    }
  }

  function showStatus(root, selector, message) {
    var target = root.querySelector(selector);
    if (!target) return;
    target.textContent = message;
    target.hidden = false;
  }

  function setBusy(button, busy) {
    button.disabled = busy;
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function request(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('cart-request-failed');
      return response.json();
    });
  }

  function currentState() {
    var allRoots = roots();
    return {
      hasCalendar: allRoots.some(function (root) { return root.dataset.hasCalendar === 'true'; }),
      isMixed: allRoots.some(function (root) { return root.dataset.isMixed === 'true'; })
    };
  }

  function updateDeferredBanner() {
    var saved = deferredItems();
    roots().forEach(function (root) {
      var banner = root.querySelector('[data-tz-deferred]');
      if (!banner) return;
      if (!saved || saved.items.length === 0) {
        banner.hidden = true;
        return;
      }
      banner.hidden = false;
      var count = saved.items.reduce(function (sum, item) { return sum + Number(item.quantity || 0); }, 0);
      var copy = banner.querySelector('[data-tz-deferred-copy]');
      if (copy) copy.textContent = count + (count === 1 ? ' Artikel wartet' : ' Artikel warten') + ', bis die erste Bestellung abgeschlossen ist.';
    });
  }

  function applyGuardState() {
    var state = currentState();
    document.documentElement.classList.toggle('tz-cart-has-calendar', state.hasCalendar);
    document.documentElement.classList.toggle('tz-cart-is-mixed', state.isMixed);

    document.querySelectorAll('button[name="checkout"][form], input[name="checkout"][form], form[action*="/cart"] button[name="checkout"], form[action*="/cart"] input[name="checkout"]').forEach(function (button) {
      if (state.isMixed) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.dataset.tzCalendarDisabled = 'true';
      } else if (button.dataset.tzCalendarDisabled === 'true') {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        delete button.dataset.tzCalendarDisabled;
      }
    });

    updateDeferredBanner();
  }

  function splitCart(button) {
    var root = button.closest('[data-tz-calendar-cart]');
    if (!root) return;
    var keep = button.dataset.tzSplitKeep;
    var items = payload(root).items;
    var deferred = items.filter(function (item) { return item.group !== keep && item.group !== 'gift'; });
    var removed = items.filter(function (item) { return item.group !== keep && item.group !== 'gift'; });

    if (!deferred.length || !removed.length) {
      showStatus(root, '[data-tz-calendar-status]', 'Die Versandgruppen konnten nicht eindeutig getrennt werden. Es wurde nichts verändert.');
      return;
    }

    setBusy(button, true);
    root.querySelectorAll('[data-tz-split-keep]').forEach(function (other) { other.disabled = true; });

    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      createdAt: new Date().toISOString(),
      group: deferred[0].group,
      items: deferred.map(function (item) {
        return {
          id: item.id,
          quantity: item.quantity,
          title: item.title,
          group: item.group,
          properties: item.properties || {},
          selling_plan: item.selling_plan || null
        };
      })
    }));

    var updates = {};
    removed.forEach(function (item) { updates[item.key] = 0; });

    request('/cart/update.js', { updates: updates })
      .then(function () { window.location.assign('/cart?tz_split=1'); })
      .catch(function () {
        localStorage.removeItem(STORAGE_KEY);
        root.querySelectorAll('[data-tz-split-keep]').forEach(function (other) { other.disabled = false; });
        setBusy(button, false);
        showStatus(root, '[data-tz-calendar-status]', 'Die Aufteilung hat nicht funktioniert. Dein Warenkorb wurde nicht verändert. Bitte versuche es erneut.');
      });
  }

  function restoreDeferred(button) {
    var root = button.closest('[data-tz-calendar-cart]');
    var saved = deferredItems();
    if (!root || !saved || !saved.items.length) return;

    setBusy(button, true);
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (cart.item_count > 0) throw new Error('cart-not-empty');
        var items = saved.items.map(function (item) {
          var entry = {
            id: item.id,
            quantity: item.quantity
          };
          if (item.properties && !Array.isArray(item.properties) && Object.keys(item.properties).length) {
            entry.properties = item.properties;
          }
          if (item.selling_plan) entry.selling_plan = item.selling_plan;
          return entry;
        });
        return request('/cart/add.js', { items: items });
      })
      .then(function () {
        localStorage.removeItem(STORAGE_KEY);
        window.location.assign('/cart?tz_restored=1');
      })
      .catch(function (error) {
        setBusy(button, false);
        showStatus(root, '[data-tz-deferred-status]', error.message === 'cart-not-empty'
          ? 'Bitte schließe zuerst die aktuelle Bestellung ab. Danach kannst du die vorgemerkten Artikel in den leeren Warenkorb zurückholen.'
          : 'Die vorgemerkten Artikel konnten nicht geladen werden. Sie bleiben gespeichert; bitte versuche es erneut.');
      });
  }

  document.addEventListener('click', function (event) {
    var checkout = event.target.closest('button[name="checkout"][form], input[name="checkout"][form], form[action*="/cart"] button[name="checkout"], form[action*="/cart"] input[name="checkout"]');
    if (checkout && currentState().isMixed) {
      event.preventDefault();
      var mixedRoot = roots().find(function (candidate) { return candidate.dataset.isMixed === 'true'; });
      if (mixedRoot) showStatus(mixedRoot, '[data-tz-calendar-status]', 'Bitte wähle zuerst, welche Versandgruppe du bestellen möchtest.');
      return;
    }

    var split = event.target.closest('[data-tz-split-keep]');
    if (split) {
      event.preventDefault();
      splitCart(split);
      return;
    }

    var restore = event.target.closest('[data-tz-restore-deferred]');
    if (restore) {
      event.preventDefault();
      restoreDeferred(restore);
    }
  });

  document.addEventListener('cart:updated', function () {
    window.setTimeout(applyGuardState, 100);
  });
  document.addEventListener('cart:refresh', function () {
    window.setTimeout(applyGuardState, 350);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyGuardState, { once: true });
  } else {
    applyGuardState();
  }
})();
